import React, {Component} from 'react';
import Criterials from '../../general/criterials';
import Options from '../../general/options';
import TableBlock from './tableBlock';
import UnitSearch from './unitSearch';
import moment from 'moment';
import swal from 'sweetalert';

import Inputmask from 'inputmask';

var Config = require('../../../../config');

class Form extends Component{
	constructor(props){
		super(props);

		this.getProcess = this.getProcess.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getData   = this.getData.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.getProcessData = this.getProcessData.bind(this);
		this.getOption = this.getOption.bind(this);
		this.handleChangeData = this.handleChangeData.bind(this);

		var aux_date = new Date();
		this.state = {
			option:"Unit",
			equipment_type_list:[],
			equipment_type:"",
			equipment_id:"",
			
			date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour:"",//this.addZero(aux_date.getHours())+':'+this.addZero(aux_date.getMinutes()),

			final_component:[],
			final_component_id:"",

			process_id:"",
			process:[],

			modify:[],
			unit_check:[],
			all_check:false,

			components:[],
			component_id:"",
			disabled_component:true,
			expired_days_iluminate:{},
			mod_cad_iluminado_days:{},
			dias:"",
			searchBy:"fecha",
			reserved_list:[]
		}
	}

	addZero(i) {
	    if (i < 10) {
	        i = "0" + i;
	    }
	    return i;
	}

	componentDidMount(){
		this.props.onRef(this);

		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=MOD_CAD_ILUMINADO_DAYS',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				mod_cad_iluminado_days: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=EXPIRED_DAYS_ILUMINATE',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				expired_days_iluminate: response
			});
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				hour:hours,
			});
		})
	}

	getOption(option){
		this.setState({
			option:option,
			component_id: "",
			final_component_id:"",
			final_component:[],
			process_id:"",
			equipment_id:"",
			modify:[]
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getProcess(e){
		var index = e.nativeEvent.target.selectedIndex;
		this.setState({
			[e.target.name]: e.target.value,
		});

		var proc =  e.nativeEvent.target[index].text;

		fetch(Config.default.apiGateway.URL+'blood_process/transformation_process?process='+proc+
			'&blood_component_id='+this.state.component_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response =>{

			if(response !== undefined){
				this.setState({
					final_component:response,
					final_component_id:response.length > 0 ? response[0].id : ""
				})

				document.getElementById('final_component_id').classList.remove('error');

			}
				
		})

		fetch(Config.default.apiGateway.URL+'equipments/by_health_facility?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&type=filtrador&active=true', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response =>{
			if(response !== undefined){
				this.setState({
					equipment_type_list:response,
					equipment_id:""
				})


			}	
		})

		var units = [];
		this.state.unit_check.map((u)=>{
			units.push(u.id);
		})

		var obj = {
			process: proc,
			units:units
		}
		fetch(Config.default.apiGateway.URL+'transformation_process/getExpiredDate', {
			method : 'post',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response =>{
			if(response !== undefined){
				response.map((res)=>{
					var index = this.state.modify.units.findIndex(obj =>
						obj.unit.id === res.id
					);

					var dias = parseInt(this.state.expired_days_iluminate.value) - 
								parseInt(this.state.mod_cad_iluminado_days.value);

					this.setState({dias:dias});

					var max_date = moment(res.caducidad).add(dias, 'days').format('YYYY-MM-DD');

					this.state.modify.units[index].unit.date_caducidad = moment(res.caducidad).format('YYYY-MM-DD');
					if(res.caducidad.indexOf('00:00') !== -1){
						this.state.modify.units[index].unit.hour_caducidad = '23:59';	
					}else{
						this.state.modify.units[index].unit.hour_caducidad = moment(res.caducidad).format('HH:mm');	
					}
					
					this.state.modify.units[index].unit.max_date = max_date;
					this.state.modify.units[index].unit.error_date = false;
					
				})
				this.forceUpdate();

			}	
		})
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[e.target.name]: e.target.value,
		});

		if(e.target.name === 'hour'){

			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{

			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500);
		}
	}

	getData(results, aux){
		this.setState({
			//components: [],
			//component_id: "",
			final_component_id:"",
			final_component:[],
			process_id:"",
			equipment_id:"",
			modify:[],
			all_check:false,
			unit_check:[],
			reserved_list:[]
		})
		
		if(aux === 'components'){
			this.setState({
				components: results
			});
		}else if(aux === 'modify'){
			this.setState({
				modify:results,
				component_id: this.criterials.state.blood_component_id,
				process: results.blood_component_has_blood_process
				//all_check:false,
				//unit_check:[],
			});

			results.units.map((d)=>{
				if(d.donation_status !== 'ACCEPTED'){
					this.props.disableBtn();
				}

				return d.status.indexOf('RECHAADA') === -1 ?
					this.setState({
						unit_check: [...this.state.unit_check, {
							id:d.unit.id, 
							value:d.unit.volume, 
							check:false
						}]
					})
				: null
			});

			setTimeout(function(){
				this.inputRef.focus();
			}.bind(this), 500);

		}else if(aux === 'component'){
			this.setState({
				component_id: results,
			});
		}else{
			this.setState({
				components:this.unit.state.components,
				component_id:results.blood_component.id,
				disabled_component:false,
			})

			var units = [];

			results.units.map(function(u, x){
				return u.map((d, i)=>{
					
					if(d.donation_status !== 'ACCEPTED'){
						this.props.disableBtn();
					}

					if(d.status === 'RESERVADA'){
						
						this.setState({
							reserved_list: [...this.state.reserved_list, {
								unit_id: d.unit.id,
								unit_number: d.unit.unit_number,
								component:d.blood_component.code,
								component_number:d.unit.component_number,
								status: d.status,
								reserved: d.reserved
							}]
						});
					}

					if(d.unit.id === aux){
						this.setState({
							unit_check: [...this.state.unit_check, {
								id:d.unit.id, 
								value:d.unit.volume, 
								check:false,
								status: d.donation_status
							}],
							//modify: [...this.state.modify, d]
						})

						units.push(d)
					}
						
				})
			}.bind(this))

			this.setState({
				modify: {
					//blood_component_has_blood_process: results.blood_component_has_blood_process,
					units: units
				},
				process: results.blood_component_has_blood_process,
			});
			
			document.getElementById('date').focus();

		}
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component?option=actives', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				components: response
			});
		});
	}

	onChecked(e){
		this.state.unit_check.map((u, j)=>{
			return u.id === parseInt(e.target.id) ?
				u.check = u.check ? false : true
			: null
		});
		this.forceUpdate();
	}

	selectAll(e){
		if(e.target.checked){
			this.setState({
				all_check:true
			})
		}else{
			this.setState({
				all_check:false
			})
		}

		this.state.unit_check.map((u, j)=>{
			if(e.target.checked)	
				u.check = true;
			else
				u.check = false;	
			
		});
		this.forceUpdate();
	}

	getProcessData(){
		var obj = {};
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm');

		obj.date = date.format('MM-DD-YYYY');
		obj.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
		obj.equipment_id = this.state.equipment_id;
		obj.blood_process_id = this.state.final_component_id;
		obj.health_facilities_id = sessionStorage.getItem('health_facilities_id');
		
		var transformation_parts = [];
		var locked = '';


		var data = this.state.modify;

		data.units.map((m, i)=>{
			var parts = {};

			if(this.state.option === "Unit"){
				parts = {
					unit_id: m.unit.id,
					volumen: m.unit.volume,
					caducidad: m.unit.date_caducidad+' '+m.unit.hour_caducidad
				}

				if(!this.dateCompare(m.unit.date_caducidad, m.unit.max_date)){
					parts.error_date = true;
					m.unit.error_date  = true;
				}else{
					m.unit.error_date  = false;
				}

				transformation_parts.push(parts);
			}else{
				if(this.state.unit_check[i].check){
					parts = {
						unit_id: m.unit.id,
						volumen: m.unit.volume,
						caducidad: m.unit.date_caducidad+' '+m.unit.hour_caducidad
					}

					if(!this.dateCompare(m.unit.date_caducidad, m.unit.max_date)){
						parts.error_date = true;
						m.unit.error_date  = true;
					}else{
						m.unit.error_date  = false;
					}

					//transformation_parts.push(parts);

					if(m.status.status === 'BLOQUEADA'){
						locked += m.unit.unit_number+', ';
					}

					transformation_parts.push(parts);
				}
			}
				
		})

		this.setState({modify: data});

		obj.transformation_parts = transformation_parts;
		obj.status = locked;

		return obj;

	}

	dateCompare(cad, max){
		var ini = moment(cad);
		var fin = moment(max);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				//document.getElementById('end_date').classList.add('error');
			}else{
				//document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	handleChangeData(e, i){
		var campo = e.target.id.split('_')[0]+'_'+e.target.id.split('_')[1];
		var id = e.target.id.split('_')[2];
		var value = e.target.value;
		var data = this.state.modify;

		data.units[i].unit[campo] = value;

		this.setState({modify:data});
	}


	render(){
		return (
			<div className="col-xs-12 ">
				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
					<div className="col-xs-12 col-sm-1" style={{paddingRight:"0"}}>
						<Options {...this.props} validate={this.props.validateInput} sendData={this.getOption} onRef={ref => (this.options = ref)} />
					</div>
					{this.state.option === 'Block' &&
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Buscar por</span>
							<select className="form-control" value={this.state.searchBy} name="searchBy" id="searchBy" 
								onChange={this.handleChange}>
								<option value="fecha">Fecha</option>
								<option value="folio">Folio</option>
							</select>
						</div>
					}

					<div className="col-xs-12 col-sm-10">
						{this.state.option === 'Block' ?
							<Criterials {...this.props} validate={this.props.validate} 
								sendData={this.getData} component={this.getComponent} 
								clear={this.props.clear}
								search={this.state.searchBy}
								onRef={ref => (this.criterials = ref)} />
						:
							<UnitSearch {...this.props} validate={this.props.validate} sendData={this.getData} onRef={ref => (this.unit = ref)} />
						}
					</div>
				</fieldset>

				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"10px"}}>Proceso</legend>
					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span>Fecha</span>
						</div>

						<div className="col-xs-12 col-sm-2">
							<input className="form-control" type="date" name="date" id="date" onChange={this.handleChange} 
								value={this.state.date || ""} required ref={(input) => { this.inputRef = input }}
								onKeyPress={(e) => this.props.validate(e)} />
						</div>

						<div className="col-xs-12 col-sm-1" style={{textAlign:"right"}}>
							<span>Hora</span>
						</div>

						<div className="col-xs-12 col-sm-1">
							<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
								data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
								required onKeyPress={(e)=>this.props.validate(e)} className="form-control"/>
							{/*<input className="form-control hour-input" type="time" name="hour" id="hour" onChange={this.handleChange} 
								value={this.state.hour || ""} onKeyPress={(e) => this.props.validate(e)} required />*/}
						</div>
					</div>

					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span>Componente a Modificar</span>
						</div>

						<div className="col-xs-12 col-sm-4" style={{textAlign:"right"}}>
							<select className="form-control" disabled  name="component_id" onChange={this.handleChange}
								value={this.state.component_id || ""} onKeyPress={(e) => this.props.validate(e)}>
								<option value="">Seleccione...</option>
								{this.state.components.map(function(t) {
									return <option key={t.component.id} 
										value={t.component.id} >{t.component.component}</option>;
								})
								}
							</select>
						</div>
					</div>

					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span>Proceso</span>
						</div>
						<div className="col-xs-12 col-sm-4">
							<select className="form-control" name="process_id" id="process_id" onChange={(e)=>this.getProcess(e)} 
								value={this.state.process_id || ""} onKeyPress={(e) => this.props.validate(e)}>
								<option value="">Seleccione...</option>
								{this.state.process.map(function(t, index) {
									return <option key={"process_"+index} 
										value={t.blodd_component_id} >{t.process}</option>;
								})
								}

							</select>
						</div>
					</div>

					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span>Componente a Obtener</span>
						</div>

						<div className="col-xs-12 col-sm-4">
							<select className="form-control" name="final_component_id" id="final_component_id" onChange={this.handleChange} 
								value={this.state.final_component_id || ""} required onKeyPress={(e) => this.props.validate(e)}>
								<option value="">Seleccione...</option>
								{this.state.final_component.map((eq, i)=>(
									<option key={eq.id} value={eq.id}>{eq.component_final_name}</option>
								))
								}
							</select>
						</div>
					</div>

					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span>Equipo</span>
						</div>

						<div className="col-xs-12 col-sm-4">
							<select className="form-control" name="equipment_id" id="equipment_id" onChange={this.handleChange} 
								value={this.state.equipment_id || ""} onKeyPress={(e) => this.props.validate(e)}>
								<option value="">Seleccione...</option>
								{this.state.equipment_type_list.map((eq, i)=>(
									<option key={eq.id} value={eq.id}>{eq.name}</option>
								))
								}
							</select>
						</div>
					</div>
					
					<div className="col-xs-12  col-sm-8 col-sm-offset-1">
						<TableBlock {...this.props} 
							option={this.state.option} 
							validate={this.props.validate} 
							data={this.state.modify} 
							checks={this.state.unit_check} 
							selectAll={this.selectAll} 
							checked={this.onChecked} 
							all={this.state.all_check} 
							process={this.state.process_id}
							onRef={ref => (this.table = ref)}
							onChangeData={this.handleChangeData} />
					</div>
				</fieldset>
			</div>
		)
	}
}

export default Form;